import styled from "styled-components";

export const Card = styled.div`
    width: 100%;
    max-width: 580px;

    background: rgba(255, 255, 255, .04);

    border: 1px solid rgba(255, 255, 255, .08);

    border-radius: ${({ theme }) => theme.borderRadius.lg};

    backdrop-filter: blur(20px);

    overflow: hidden;

    box-shadow: 0 25px 60px rgba(0,0,0,.35);

    box-sizing: border-box;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 20px 24px;

    border-bottom: 1px solid rgba(255, 255, 255, .06);
`;

export const Logo = styled.h3`
    color: ${({ theme }) => theme.colors.white};

    font-size: 18px;

    font-weight: 700;
`;

export const User = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    color: ${({ theme }) => theme.colors.gray};

    font-size: 14px;
`;

export const Status = styled.div`
    width: 8px;
    height: 8px;

    border-radius: 50%;

    background: #4ade80;
`;

export const Content = styled.div`
    padding: 30px;
    box-sizing: border-box;
`;

export const CardGrid = styled.div`
    display: grid;

    grid-template-columns: repeat(2, 1fr);

    gap: 20px;

    width: 100%;

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`;

export const ServiceCard = styled.div`
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    text-align: center;

    min-height: 220px;
    
    background: rgba(255, 255, 255, .03);

    border: 1px solid rgba(255, 255, 255, .05);

    border-radius: 18px;

    padding: 24px;

    transition: 
        transform .3s ease,
        border-color .3s ease,
        box-shadow .3s ease;

    cursor: default;

    &:hover {
        transform: translateY(-4px);

        border-color: ${({ theme }) => theme.colors.primary};

        box-shadow: 0 16px 40px rgba(0,0,0,.25);
    }
`;

export const Icon = styled.div`
    font-size: 30px;

    margin-bottom: 16px;
`;

export const ServiceTitle = styled.h4`
    color: ${({ theme }) => theme.colors.white};

    font-size: 18px;

    margin-bottom: 10px;
`;

export const ServiceDescription = styled.p`
    color: ${({ theme }) => theme.colors.gray};

    font-size: 14px;

    line-height: 1.6;
`;